import type { PublicApiKey } from '#packages/apilib';
import type { createConcurrentUsersApi } from './concurrentUsersWrapper';

export const ConcurrentUsersApiKey: PublicApiKey<
  typeof createConcurrentUsersApi
> = {
  name: 'ConcurrentUsersApi',
  public: true,
};
